module.exports = "<div class=\"date-input\">\n  <mat-form-field>\n    <input matInput [matDatepicker]=\"picker\" placeholder=\"choisissez une date\" (dateInput)=\"dateChange($event)\" [value]=\"ownData\"\n      disabled>\n    <mat-datepicker-toggle matSuffix [for]=\"picker\"></mat-datepicker-toggle>\n    <mat-datepicker #picker disabled=\"false\"></mat-datepicker>\n  </mat-form-field>\n</div>"


//////////////////
// WEBPACK FOOTER
// C:/Users/Quentin/projets/kontractor/src/app/components/form/date-picker-input/date-picker-input.component.html
// module id = ../../../../../src/app/components/form/date-picker-input/date-picker-input.component.html
// module chunks = main